import * as model from "@/model/master/processConf/ProcessEnergy";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.ProcessEnergy(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

function time2str(time) {
  let date = new Date;
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  let h = time.getHours();
  let m = time.getMinutes();
  let s = time.getSeconds();
  return `${year}-${month+1}-${d} ${h}:${m}:${s}`;
}

const baseUrl = process.env.VUE_APP_MASTER_API_URL + "master-service/master";

const processEnergyStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentProcessEnergy: {},
  },
  mutations: {
    setCurrentProcessEnergy(state, data) {
      state.currentProcessEnergy = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("processEnergy/setCurrentProcessEnergy", item, {
        root: true
      });
      router.push({
        name: "processEnergyEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/processEnergy/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/processEnergy/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/processEnergy/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/processEnergy/getLength',
      }, { root: true })
    },
    saveCurrentProcessEnergy(context) {
      return context.dispatch('saveProcessEnergy', context.state.currentProcessEnergy);
    },
    saveProcessEnergy(context, processEnergy) {
      let data = new FormData();
      let id = processEnergy.id > 0 ? processEnergy.id : -1;
      data.append('id', id);
      data.append('optionId', processEnergy.optionId);
      data.append('optionName', processEnergy.optionName); 

      data.append('energyId', processEnergy.energyId);      
      data.append('energyCode', processEnergy.energyCode);
      data.append('energyName', processEnergy.energyName);  
      data.append('energyUnit', processEnergy.energyUnit);  

      return context.dispatch('api/post', {
        url: baseUrl + '/processEnergy',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(processEnergyStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)